import { lazy } from 'react';

const ApprovalList = lazy(() => import('./list'));
const ApprovalDetails = lazy(() => import('./details'));

export { ApprovalList, ApprovalDetails };
